module.exports = __webpack_public_path__ + "img/6_of_Clubs.svg.c882e480.png";